import "./UserDetailsEditComponent.scss";
import * as Yup from "yup";
import React, {useCallback, useEffect, useState} from "react";
import {Field, FieldProps, Form, Formik, FormikHelpers} from "formik";
import CommonService from "../../../../../shared/services/common.service";
import Grid from "@mui/material/Grid";
import FormikInputComponent from "../../../../../shared/components/core/formik-input/FormikInputComponent";
import FormikDatePickerComponent
    from "../../../../../shared/components/core/formik-date-picker/FormikDatePickerComponent";
import formValidationRules from "../../../../../shared/services/validation.service";
import FormikSelectDropdownComponent
    from "../../../../../shared/components/core/formik-select-dropdown/FormikSelectDropdownComponent";
import FromikPhoneNumberComponent
    from "../../../../../shared/components/core/fromik-phone-number/FromikPhoneNumberComponent";
import ButtonComponent from "../../../../../shared/components/core/button/ButtonComponent";

interface UserDetailsEditComponentProps {
    userDetails: any;
    onUpdateComplete: Function;
    onEditCancel: Function;
}

const UserDetailsValidationSchema = Yup.object({
    firstName: Yup.string()
        .required("First Name  is required")
        .max(100, 'First name maximum limit should be 100 characters')
        .nullable(),
    middleName: Yup.string()
        .max(100, 'Middle name maximum limit should be 100 characters')
        .nullable(),
    lastName: Yup.string()
        .required("Last Name  is required")
        .max(100, 'Last name maximum limit should be 100 characters')
        .nullable(),
    dateOfBirth: Yup.date()
        .typeError("Please Enter valid Date")
        .min(new Date(1900, 0, 1), "Date of birth should be greater than 01/01/1900")
        .max(new Date(), "Can not be in the future")
        .nullable(),
    gender: Yup.string().required('Gender is Required').nullable(),
    emailId: Yup.string().required("Email ID is required")
        .email("Invalid Email ID")
        .nullable()
        .matches(/^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/, "Enter a valid Email ID"),
    mobileNumber: Yup.string()
        .nullable()
        .required("Mobile Number is Required")
        .matches(/^[(]{0,1}[0-9]{3}[)]{0,1}[-\s]{0,1}[0-9]{3}[-\s]{0,1}[0-9]{4}$/, "Mobile Number should be 10 digits"),

});

interface UserDetailsFormValues {
    firstName: string;
    middleName: string;
    lastName: string;
    dateOfBirth: string;
    gender: string;
    emailId: string;
    mobileNumber: string;
}

const UserDetailsInitialValues: UserDetailsFormValues = {
    firstName: "",
    middleName: "",
    lastName: "",
    dateOfBirth: "",
    gender: "",
    emailId: "",
    mobileNumber: "",
}
const UserDetailsEditComponent = (props: UserDetailsEditComponentProps) => {
    const {userDetails, onEditCancel, onUpdateComplete} = props;
    const [userDetailsFormValues, setUserDetailsFormValues] = useState<UserDetailsFormValues>(UserDetailsInitialValues);

    const onFormSubmit = useCallback((values: any, {setSubmitting, setErrors, validateForm}: FormikHelpers<any>) => {
        const payload = {...values};
        payload.mobileNumber = payload.mobileNumber?.replace(/[^0-9]/g, "");
        setSubmitting(true);
        CommonService._user.editUser(userDetails?.id, payload)
            .then((response: any) => {
                setSubmitting(false);
                onUpdateComplete(response?.data);
            })
            .catch((error: any) => {
                setSubmitting(false);
                CommonService.handleErrors(setErrors, error);
            }).finally(() => {

        });
    }, [userDetails, onUpdateComplete]);

    useEffect(() => {
        if (userDetails) {
            const tempUserDetails = {
                ...userDetails,
                mobileNumber: CommonService.getMaskedMobileNumber(userDetails?.mobileNumber)
            }
            setUserDetailsFormValues(tempUserDetails);
        }
    }, [userDetails]);


    return (
        <div className={'user-details-edit-component  details-tab-data-content'}>
            <Formik
                initialValues={userDetailsFormValues}
                validationSchema={UserDetailsValidationSchema}
                validateOnChange={true}
                validateOnBlur={true}
                validateOnMount={true}
                enableReinitialize={true}
                onSubmit={onFormSubmit}
            >
                {({isSubmitting, errors, dirty, values, isValid, setFieldValue, validateForm}) => {
                    // eslint-disable-next-line react-hooks/rules-of-hooks
                    useEffect(() => {
                        validateForm();
                    }, [validateForm, values, errors]);
                    return (
                        <Form noValidate={true} className={"patient-basic-details-add-holder"}>
                            <div className="t-form-controls-wrapper">
                                <div className="form-sub-title">Personal Details</div>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                        <Field name={'firstName'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikInputComponent
                                                        label={'First Name'}
                                                        placeholder={'Enter First Name'}
                                                        type={"text"}
                                                        required={true}
                                                        formikField={field}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                        <Field name={'middleName'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikInputComponent
                                                        label={'Middle Name'}
                                                        placeholder={'Enter Middle Name'}
                                                        type={"text"}
                                                        required={false}
                                                        formikField={field}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </Grid>
                                </Grid>

                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                        <Field name={'lastName'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikInputComponent
                                                        label={'Last Name'}
                                                        placeholder={'Enter Last Name'}
                                                        type={"text"}
                                                        required={true}
                                                        formikField={field}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                        <Field name={'dateOfBirth'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikDatePickerComponent
                                                        label={'Date of Birth'}
                                                        formikField={field}
                                                        required={false}
                                                        maxDate={formValidationRules.eighteenYearsAgo}
                                                        placeholder={'Enter Date of Birth'}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>
                                        <Field name={'gender'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikSelectDropdownComponent
                                                        label={'Gender'}
                                                        options={CommonService._staticData.genderOptions}
                                                        placeholder={'Select Gender'}
                                                        valueKey={'code'}
                                                        required={true}
                                                        getOptionLabel={(option) => (option.title)}
                                                        formikField={field}/>
                                                )
                                            }
                                        </Field>
                                    </Grid>
                                    <Grid item xs={12} sm={12} md={6} xl={6}>

                                    </Grid>
                                </Grid>
                                <div className="horizontal-line"/>
                                <div className="form-sub-title">Contact Details</div>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <Field name={'emailId'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FormikInputComponent
                                                        label={'Email ID'}
                                                        placeholder={'Enter Email ID'}
                                                        type={"email"}
                                                        required={true}
                                                        disabled={true}
                                                        formikField={field}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Field name={'mobileNumber'}>
                                            {
                                                (field: FieldProps) => (
                                                    <FromikPhoneNumberComponent
                                                        label={'Mobile Number'}
                                                        placeholder={'(000) 000-0000'}
                                                        maxLength={14}
                                                        required={true}
                                                        formikField={field}
                                                    />
                                                )
                                            }
                                        </Field>
                                    </Grid>
                                </Grid>
                            </div>
                            <div className={"form-action-section-edit"}>
                                <ButtonComponent
                                    className={"width-25"}
                                    color={"secondary"}
                                    type={"button"}
                                    variant={"outlined"}
                                    disabled={isSubmitting}
                                    fullWidth={false}
                                    handleClick={() => {
                                        onEditCancel()
                                    }}
                                >
                                    Cancel
                                </ButtonComponent>
                                <ButtonComponent
                                    className={"width-25"}
                                    color={"primary"}
                                    type={"submit"}
                                    variant={"contained"}
                                    disabled={!(isValid && dirty)}
                                    fullWidth={false}
                                    isLoading={isSubmitting}
                                >
                                    Save
                                </ButtonComponent>
                            </div>
                        </Form>
                    );
                }}
            </Formik>
        </div>
    );

};

export default UserDetailsEditComponent;
